<template>
  <div>
    <LegOverviewDialog
      ref="legOverviewDialog"
      v-if="showLegDialog"
      :visible="showLegDialog"
      :leg-id="selectedLegId"
      @close="
        showLegDialog = false
        refresh()
      "
    >

    </LegOverviewDialog>
    <v-data-table
      class="table-cursor osis-table elevation-2"
      :headers="headers"
      :items="latestLegs"
      :loading="loading"
      item-key="id"
      :hide-default-footer="true"
      @click:row="showLeg"
      :footer-props="{
        'next-icon':$icons.mdiChevronRight,
        'last-icon':$icons.mdiChevronDoubleRight,
        'prev-icon':$icons.mdiChevronLeft,
        'first-icon':$icons.mdiChevronDoubleLeft
      }"
    >
      <template v-slot:[`item.name`]="{ item }">
        <v-tooltip
          top
          content-class="osis-tooltip"
          v-if="item.name.length > nameStringLegth"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              class="no-wrap-cell"
            >
              {{ shortenString(item.name) }}
            </div>
          </template>
          <span>{{item.name}}</span>
        </v-tooltip>
        <div
          v-else
          class="no-wrap-cell"
        >
          {{ shortenString(item.name) }}
        </div>
      </template>
      <template v-slot:[`item.departure`]="{ item }">
        <div
          class="no-wrap-cell"
          v-if="item.departure_port_call"
        >
          {{ item.departure_port_call.date }}
        </div>
      </template>
      <template v-slot:[`item.chief_scientist`]="{ item }">
        <div class="no-wrap-cell">
          <span v-if="item.chief_scientist">
            {{ item.chief_scientist.split(',')[0].trim() }}
          </span>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import apiRequests from '@/mixins/apiRequests'

export default {
  name: 'LatestLegs',
  mixins: [apiRequests],
  components: {
    LegOverviewDialog: () => import('@/components/Legs/LegOverviewDialog.vue'),
  },
  props: ['selectedContextId'],
  data() {
    return {
      nameStringLegth: 12,
      numberOfLegs: 5,
      latestLegs: [],
      loading: true,
      options: {},
      selectedLegId: null,
      showLegDialog: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: false
        },
        {
          text: 'Departure',
          value: 'departure',
          sortable: false
        },
        {
          text: 'Chief Scientist',
          value: 'chief_scientist',
          sortable: false,
        },
      ]
    }
  },
  watch: {
    '$store.state.token': function () {
      this.getLatestLegs()
    },
    'selectedContextId': function () {
      this.getLatestLegs()
    }
  },
  computed: {
    filter_string: function () {
      let filter = {}
      if (this.selectedContextId) { filter.contexts = [{ 'id': this.selectedContextId }] }
      return JSON.stringify(filter)
    },
  },
  async mounted() {
    await this.getLatestLegs()
  },
  methods: {
    async getLatestLegs() {
      this.loading = true
      const requestParams = {
        method: "GET",
        url: 'expeditions',
        queryParams: {
          page: 1,
          per_page: this.numberOfLegs,
          order: '{"last_updated":"desc"}',
          filter: this.filter_string,
        }
      }
      try {
        const res = await this.osisApiRequest(requestParams)
        let page_object = await res.json()
        this.latestLegs = page_object.data
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    showLeg(leg) {
      this.selectedLegId = leg.id
      this.showLegDialog = true
    },
    async refresh() {
      await this.getLatestLegs()
    },
    shortenString(str) {
      if (str.length <= this.nameStringLegth) {
        return str;
      } else {
        return str.substring(0, this.nameStringLegth) + '...';
      }
    }
  }
}
</script>